import React, { useEffect, useState } from "react";
import {
  Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Typography, Chip,
} from "@mui/material";
import { SideBarWidth } from "../../utils/SideBarWidth";
import { WalletsRequests } from "../../api/requests/Wallets/wallets";
import { Colors } from "../../Theme/Theme";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import CancelIcon from "@mui/icons-material/Cancel";

const statusConfig = {
  APPROVED: { color: Colors.insuranceGreen, bg: Colors.greenSoft, icon: <CheckCircleIcon sx={{ fontSize: 14 }} /> },
  PENDING: { color: "#F59E0B", bg: "#FFFBEB", icon: <HourglassEmptyIcon sx={{ fontSize: 14 }} /> },
  REJECTED: { color: "#EF4444", bg: "#FEF2F2", icon: <CancelIcon sx={{ fontSize: 14 }} /> },
};

export default function WithDrawalHistory() {
  const [walletHistory, setWalletHistory] = useState([]);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const response = await WalletsRequests.WithdrawalRequestById();
        setWalletHistory(response || []);
      } catch (error) {}
    };
    fetchHistory();
  }, []);

  return (
    <Box sx={{
      width: { xs: "100%", md: `calc(100% - ${SideBarWidth}px)` },
      ml: { md: `${SideBarWidth}px` },
      minHeight: "100vh", backgroundColor: Colors.bgColor,
    }}>
      <Box sx={{ px: { xs: 2, md: 3 }, py: 3, maxWidth: 1200 }}>
        <Box sx={{ mb: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
            <ReceiptLongIcon sx={{ fontSize: 22, color: Colors.primary }} />
            <Typography sx={{ fontWeight: 700, color: Colors.primaryTextColor, fontSize: { xs: "20px", md: "24px" }, letterSpacing: "-0.02em" }}>
              Withdrawal History
            </Typography>
          </Box>
          <Typography sx={{ color: Colors.secondaryColor, fontSize: "13px" }}>
            Track all your withdrawal requests and their statuses.
          </Typography>
        </Box>

        <Box sx={{ backgroundColor: Colors.white, borderRadius: "12px", border: `1px solid ${Colors.dividerColor}`, overflow: "hidden" }}>
          <Box sx={{ px: 3, py: 2 }}>
            <Typography sx={{ fontWeight: 700, fontSize: "15px", color: Colors.primaryTextColor }}>
              Withdrawal Requests
            </Typography>
          </Box>
          <TableContainer sx={{ overflowX: "auto" }}>
            <Table>
              <TableHead>
                <TableRow>
                  {["Amount (Rs.)", "Status", "Date"].map((header) => (
                    <TableCell key={header} sx={{
                      color: Colors.secondaryColor, py: 1.5, px: 3,
                      fontWeight: 600, fontSize: "11px", letterSpacing: "0.5px",
                      textTransform: "uppercase", backgroundColor: Colors.bgColor,
                      borderBottom: `1px solid ${Colors.dividerColor}`,
                    }}>
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {walletHistory.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={3} sx={{ py: 6, textAlign: "center", borderBottom: "none" }}>
                      <Typography sx={{ color: Colors.light_gray, fontSize: "14px" }}>No withdrawal requests found</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  walletHistory.map((transaction) => {
                    const status = statusConfig[transaction.status] || statusConfig.PENDING;
                    return (
                      <TableRow key={transaction.id} sx={{ "&:last-child td": { borderBottom: "none" }, "&:hover": { backgroundColor: Colors.bgColor } }}>
                        <TableCell sx={{ borderBottom: `1px solid ${Colors.dividerColor}`, py: 1.5, px: 3 }}>
                          <Typography sx={{ fontWeight: 600, fontSize: "14px", color: Colors.primaryTextColor }}>
                            Rs. {transaction.amount}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ borderBottom: `1px solid ${Colors.dividerColor}`, py: 1.5, px: 3 }}>
                          <Chip
                            icon={status.icon}
                            label={transaction.status}
                            size="small"
                            sx={{
                              height: 24, fontSize: "11px", fontWeight: 600,
                              backgroundColor: status.bg, color: status.color,
                              "& .MuiChip-icon": { color: status.color },
                              "& .MuiChip-label": { px: 0.8 },
                            }}
                          />
                        </TableCell>
                        <TableCell sx={{ borderBottom: `1px solid ${Colors.dividerColor}`, py: 1.5, px: 3 }}>
                          <Typography sx={{ fontSize: "13px", color: Colors.secondaryColor }}>
                            {new Date(transaction.timestamp).toLocaleString()}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </Box>
  );
}
